import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseResponse, BaseService } from 'src/app/core/services/base.service';
import { GetSidesbarResponse } from './shared-sidebar.interface';

@Injectable({
    providedIn: 'root',
})
export class SharedSidebarService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    /**
     * getSideMenu() - Buscar os itens de menu do departamento
     * @param departmentId : Identificador do departamento
     */
    getSideMenu(departmentType) {
        // Instacia o body através de BaseSerive.setBody();
        let body = this.setBody();

        // Inicializar o id do departamento selecionado
        body.set('departmentType', departmentType);

        return this.http
            .post<BaseResponse<GetSidesbarResponse>>(
                this.urlService + this.routeAdress.route_menu_sidebar,
                body.toString()
            )
            .pipe(catchError(this.serviceError));
    }
}
